import * as S from "./styled";
import { useForm, SubmitHandler } from "react-hook-form";
import axiosInstance from "services/axiosInstance";
/**
 * Components
 */
import LayoutWithList from "../../../LayoutModal/WithList";
import ActionButton from "../../../Button/ActionButton";
import Delete from "../../Delete";
import Update from "../Update";
/**
 * hooks
 */
import apiRequest from "../../../../hooks/apiRequest";
import { useMultipleModal } from "../../../../hooks/useMultipleModal";
import { useEffect, useState } from "react";
/**
 * Icons
 */
import { PencilSimple, Trash } from "@phosphor-icons/react";
/**
 * Interfaces
*/
import { Inputs, ITypeLens } from "Interfaces/ITypeLens";

interface ICreate {
  isOpenModalBraind: boolean;
  setModalClose: () => void;
  refreshFrames: () => void;
}

export default function CreateTypeLens({
  isOpenModalBraind,
  setModalClose,
  refreshFrames,
}: ICreate) {
  const {
    register,
    handleSubmit: handleFormSubmit,
    reset,
    formState: { errors },
  } = useForm<Inputs>();

  const tableHead = ["#", "Nome", "Ações"];
  const [data, setData] = useState<ITypeLens[]>([]);
  const [openModalOptId, setOpenModalOptId] = useState<number | null>(null);
  const { isOpenModal, toggleModalVisibility } = useMultipleModal();

  const clickPopTable = (id: number, acao: string) => {
    setOpenModalOptId(id);
    toggleModalVisibility(acao);
  };

  const fetchData = async () => {
    try {
      const response = await axiosInstance.get(`type-lens`);
      setData(response.data);
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    try {
      const response = await apiRequest("type-lens", "POST", data);
      if (response.status === 201) {
        alert("Tipo da Lente criada com sucesso!");
        fetchData();
        refreshFrames();
      }
    } catch (error: any) {
      alert(error.message || "Ocorreu um erro ao criar o tipo da lente.");
    }
  };

  const onClose = () => {
    setModalClose();
    reset();
  };

  if (isOpenModalBraind) {
    return (
      <LayoutWithList
        title="Registrar Tipo da Lente"
        subTitle="Cadastre um novo tipo de lente em sua base de dados."
        setModalClose={onClose}
      >
        <S.Container>
          <S.SeparateDiv>
            <S.FormInput>
              <S.Label>
                Tipo da Lente
                <span>*</span>
              </S.Label>
              <S.Input
                placeholder="Informe o Tipo da Lente"
                type="text"
                {...register("type_lens", { required: true })}
              />
              {errors.type_lens && <S.InforErro>Campo Obrigatório</S.InforErro>}
            </S.FormInput>

            <S.ContentButton>
              <ActionButton
                name="Salvar"
                onClick={handleFormSubmit(onSubmit)}
              />
            </S.ContentButton>
          </S.SeparateDiv>
        </S.Container>

        <S.Footer>
          <S.TitleList>Tipos Cadastrados</S.TitleList>

          <S.Table>
            <thead>
              <tr>
                {tableHead.map((val) => {
                  return <th>{val}</th>;
                })}
              </tr>
            </thead>
            <tbody>
              {data.map((val, index) => {
                return (
                  <tr>
                    <td>{index + 1}</td>
                    <td>{val.type_lens || "-"}</td>
                    <td>
                      <S.ContentButton>
                        <S.ButtonIconTable
                          onClick={() => clickPopTable(val.id, "update")}
                        >
                          <PencilSimple size={20} />
                        </S.ButtonIconTable>

                        <S.ButtonIconTable
                          onClick={() => clickPopTable(val.id, "delete")}
                        >
                          <Trash size={20} color="red" />
                        </S.ButtonIconTable>
                      </S.ContentButton>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </S.Table>
        </S.Footer>

        <Update
          isOpenModalUpdate={isOpenModal("update")}
          setModalClose={() => toggleModalVisibility("update")}
          selectedUrlId={openModalOptId}
          updateList={fetchData}
        />

        <Delete
          updateList={fetchData}
          endpoint="type-lens"
          selectedProductId={openModalOptId}
          isOpenModal={isOpenModal("delete")}
          setModalClose={() => toggleModalVisibility("delete")}
        />
      </LayoutWithList>
    );
  }
  return null;
}
